import * as React from 'react';

import { CTA, styled } from '@volkswagen-onehub/components-core';
import { ChevronUp } from '@volkswagen-onehub/icons-core';

import { zoomStoreActions } from '../../store';
import { testId } from '../../test-utils/constants';

export function MinimizeButton() {
	return (
		<StyledCTA
			data-testid={testId('Exit_Minimized_State_Button')}
			emphasis="tertiary"
			tag="button"
			onClick={() => {
				return zoomStoreActions.resetZoom();
			}}
			icon={<ChevronUp aria-label="Exit minimized state" />}
		/>
	);
}

const StyledCTA = styled(CTA)`
	// Use same grid area as fullscreenButton
	grid-area: fullscreenButton;

	margin-left: ${({ theme }) => (theme.direction === 'ltr' ? 'auto' : theme.size.static250)};
	margin-right: ${({ theme }) => (theme.direction === 'ltr' ? theme.size.static250 : 'auto')};
`;
